export { DwelingIcon } from './DwelingIcon'
